module.exports = __webpack_public_path__ + "img/price-zuckering.a8b8b0f4.png";